// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data
import LessonsData from "layouts/lessons/data/lessonsTableData";
import { useSelector } from "react-redux";
import { Fab, LinearProgress } from "@mui/material";

import React, { useState } from "react";

import AddIcon from "@mui/icons-material/Add";

import ModalAdd from "layouts/lessons/others/modalAdd";

function Tables() {
  const fetched = useSelector((state) => state.lesson.fetched);

  const [add, setAdd] = useState(false);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              sx={{ display: "flex" }}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography sx={{ flexGrow: 1 }} variant="h6" color="white">
                Leçons
              </MDTypography>

              <Fab
                color="inherit"
                aria-label="add"
                size="small"
                sx={{ float: "right" }}
                onClick={() => setAdd(true)}
              >
                <AddIcon />
              </Fab>
            </MDBox>
            {add && <ModalAdd open finished={() => setAdd(false)} />}
            <MDBox pt={3} sx={{ overflowX: "hidden" }}>
              <LessonsData />
              {!fetched && <LinearProgress color="info" />}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default Tables;
